import * as React from 'react';
export const barChartSvg = React.forwardRef(function barChartSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.25.25A.75.75 0 0 1 2 1v8.75c0 .138.112.25.25.25H11a.75.75 0 0 1 0 1.5H2.25A1.75 1.75 0 0 1 .5 9.75V1a.75.75 0 0 1 .75-.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 4.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 4 4.25Zm3-2a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 7 2.25Zm3-2a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 10 .25Z',
    }),
  );
});
barChartSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var barChart = {
  category: 'icon',
  colorable: true,
  name: 'barChart',
  svg: barChartSvg,
};
